import { render, staticRenderFns } from "./YesNoSelectbox.vue?vue&type=template&id=58240f04&scoped=true&"
import script from "./YesNoSelectbox.vue?vue&type=script&lang=js&"
export * from "./YesNoSelectbox.vue?vue&type=script&lang=js&"
import style0 from "./YesNoSelectbox.vue?vue&type=style&index=0&id=58240f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58240f04",
  null
  
)

export default component.exports